/*
 * @Author: liyu
 * @Date: 2022-04-26 10:11:25
 * @LastEditTime: 2022-04-26 10:15:26
 * @Description: file content
 * @FilePath: /sensors-www/src/components/Entertainment/ScanCodeEntertainmentButton/index.tsx
 */

import React from 'react'
import ScanCodeConsultButton from "components/ScanCodeConsultButton";
import * as styles from "./index.module.less";

interface ScanCodeEntertainmentButtonProps {
    className?: string;
    buttonText?: string;
    imgBottomText?: string;
    qrcode?: string;
    alt?: string;
    buttonType?: string;
    ghost?: boolean;
    style?: React.CSSProperties;
  }
const ScanCodeEntertainmentButton: React.FC<ScanCodeEntertainmentButtonProps> = (props) => {
    return (<>
        <ScanCodeConsultButton className={styles.entertainmentButton} {...props}/>
    </>)
}

export default ScanCodeEntertainmentButton